import {
  Briefcase,
  Building2,
  Circle,
  HeadsetIcon,
  Home,
  LifeBuoy,
  Minus,
  Phone,
  Printer,
  Smartphone,
} from 'lucide-react';

export const types = ['Home', 'Work', 'Mobile', 'Main', 'Support', 'Direct', 'Fax', 'Toll-Free', 'Other'];
type TTypes = (typeof types)[number];

export function phoneTypeIcon(type: TTypes | undefined) {
  const obj = {
    home: Home,
    work: Briefcase,
    mobile: Smartphone,
    main: Building2,
    support: LifeBuoy,
    direct: Phone,
    fax: Printer,
    'toll-free': HeadsetIcon,
    other: Circle,
  };

  if (!type) {
    return Minus;
  }

  return obj[type as keyof typeof obj] ?? Minus;
}

export const typesOptions = [
  { name: 'None', value: '' },
  ...types.map((item) => ({ name: item, value: item.toLocaleLowerCase() })),
];

type TOptions = (typeof typesOptions)[number];

export function stringToType(strType: string): TOptions {
  return typesOptions.find((item) => item.value === strType) ?? ({} as TOptions);
}
